module.exports = __webpack_public_path__ + "ad59b37588b45cecd22afb4b7bed5fa9.svg";